import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles, useTheme } from 'react-jss'

import { isClientSide } from '../../Common/utils'
import SVG from '../../SVG/SVG'

const isActive = 'notNow'

const useStyles = createUseStyles({
  bookingTitleBar: ({ theme }) => ({
    //bookingWidgetWrapperbackgroundColor: bgColor || theme.colors.deepsea,
    backgroundColor: theme.colors.red,
    '& > div': {
      ...theme.wrappers.standard,
      display: 'flex',
      alignItems: 'center',
      '@media (max-width: 900px)': {
        flexDirection: 'column',
        alignItems: 'start',
      },
    },
  }),
  hideondesktop: {
    '@media (min-width: 900px)': {
      display: 'none',
    },
  },
  hideonmobile: {
    '@media (max-width: 900px)': {
      display: 'none',
    },
  },
  bookingTitle: ({ theme }) => ({
    ...theme.headings.bookingTitleBarHeading,
    color: theme.colors.white,
    fontSize: 28,
    margin: 0,
    padding: 0,
    marginRight: '58px',
    '@media (max-width: 900px)': {
      marginRight: '0px',
      fontSize: 22,
    },
  }),
  bookingToggle: ({ theme }) => ({
    padding: '10px 15px 8px',
    borderRadius: '16px',
    backgroundColor: '#FFF',
    color: theme.colors.red,
    lineHeight: '12px',
    fontSize: 12,
    fontWeight: 'bold',
    margin: 'auto',
    boxSizing: 'border-box',
    cursor: 'pointer',
    zIndex: 100,
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: '0',

    '@media (max-width: 900px)': {
      position: 'absolute',
      right: '10px',
      padding: '8px 15px 6px 15px',
    },

    '& > svg': {
      transform: 'rotate(-90deg)',
      transition: `transform ${theme.animations.animate}`,
      color: theme.colors.red,
      fill: theme.colors.red,
      margin: 'auto',
      marginLeft: 8,
    },

    '&.is-closed >  svg': {
      transform: 'rotate(90deg)',
    },

    '&:hover': {
      backgroundColor: theme.colors.cloudyBlue,
    },
  }),
  bookingLinksContainer: {
    '@media (max-width: 900px)': {
      marginTop: '15px',
      padding: '25px 0',
      overflow: 'hidden',
      width: 'calc(100% + 10px)',
      marginRight: '-10px',
      '& > div': {
        width: '1000px',
      },
    },
  },
  bookingLinks: ({ theme }) => ({
    color: '#fff',
    fontFamily: 'ITC Avant Garde',
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '18px',
    borderRadius: '31px',
    padding: '15px 26px 11px 26px',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&.is-active': {
      backgroundColor: theme.colors.redHover,
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }),
})

const BookingTitleBar = ({ bgColor, widgetOpen, widgetLocked, children }) => {
  const theme = useTheme()
  const classes = useStyles({ bgColor, theme })
  const [widgetOpenState, setwidgetOpenState] = useState()

  useEffect(() => {
    setwidgetOpenState(widgetOpen)
  }, [widgetOpen])

  const toggleFormBook = e => {
    if (isClientSide) {
      let book = document.querySelector('#formBook')
      let toggle = document.querySelector('#formBookToggle')
      // let toggleText = document.querySelector('#formBookToggleText')

      if (book) {
        if (book.classList.contains('is-closed')) {
          book.classList.remove('is-closed') // Show Booking
          toggle.classList.remove('is-closed')
          setwidgetOpenState(true)
          // toggleText.innerHTML = 'Hide Itinerary'
        } else {
          book.classList.add('is-closed') // Hide Booking
          toggle.classList.add('is-closed')
          setwidgetOpenState(false)
          // toggleText.innerHTML = 'Change Itinerary'
        }
      }
    }
  }

  return (
    <div className={classes.bookingTitleBar}>
      <div>
        <h2 className={classes.bookingTitle}>{children}</h2>

        {widgetOpenState && (
          <div className={classes.bookingLinksContainer}>
            <div>
              <a
                className={`${classes.bookingLinks} ${
                  isActive !== 'truckBus' && isActive !== 'cancel' ? 'is-active' : ''
                }`}
                href=""
              >
                Car &amp; Passenger Vehicles
              </a>
              {/* <a
                className={`${classes.bookingLinks} ${isActive === 'cancel' ? 'is-active' : ''}`}
                href=""
              >
                Modify/Cancel Booking
              </a> */}
            </div>
          </div>
        )}

        {widgetLocked ? null : (
          <div
            id="formBookToggle"
            className={`${classes.bookingToggle} ${widgetOpenState ? '' : 'is-closed'}`}
            onClick={e => toggleFormBook(e)}
          >
            <span id="formBookToggleText">
              <span className={classes.hideonmobile}>
                {widgetOpenState ? 'Hide Itinerary' : 'Show Itinerary'}
              </span>
              <span className={classes.hideondesktop}>{widgetOpenState ? 'Hide' : 'Show'}</span>
            </span>
            <SVG name={'Chevron'} width={12} height={12} colorOne={'#C8102E'} />
          </div>
        )}
      </div>
    </div>
  )
}

BookingTitleBar.propTypes = {
  children: PropTypes.string,
}

export default BookingTitleBar
